import {
  View,
  Accordion,
  Disclosure,
  DisclosureTitle,
  DisclosurePanel,
  Flex,
  TextField,
  Divider,
  NumberField,
  ComboBox,
  Item,
  ActionButton,
} from "@adobe/react-spectrum";
import React, { useEffect, useState } from "react";
import { ContactFormData } from "../AddNewPerson";
import ReferenceMarketingChanelDropDown from "../formComponents/ReferenceMarketingChanelDropDown";
import CompanyNameDropDown from "../formComponents/CompanyNameDropdown";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { ListContactListRequest } from "../../../../../services/soap/main/requests/ListContactListRequest";
import { Check, ExclamationTriangle, Triangle } from "react-bootstrap-icons";
import { ListMessageActionRequest } from "../../../../../services/soap/message/requests/ListMessageActionRequest";
import UserDropDown from "../formComponents/UserDropDown";
import { useTranslation } from "react-i18next";

// Separate component sections
export const CompanyBaseInfo: React.FC<{
  data: {
    name1: string;
    regNumber: string;
    VATNumber: string;
    legalForm: string;
    legalFormName: string;
    reference: string;
    trackingCode: string;
    category: string;
    dueDays: number;
    refId?:string;
    refStandardtype?:string;
    marketingChannel?: string;
    user?:string;
    city?:string;
    country?:string;
    street?:string;
    zip?:string;
  };
  onChange: (data: {
    name1: string;
    regNumber: string;
    VATNumber: string;
    legalForm: string;
    legalFormName: string;
    reference: string;
    trackingCode: string;
    category: string;
    dueDays: number;
    refId?:string;
    refStandardtype?:string;
    marketingChannel?: string;
    user:string;
    city:string;
    country:string;
    street:string;
    zip:string;
  }) => void;
  validationErrors: any;
  setValidationErrors:(data:any)=>void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}> = ({ data,
   onChange,
  validationErrors,
  expandedSectionKey,
  setExpandedSectionKey,
  fieldConfig,
  validationStatus,
  setValidationStatus,
  setValidationErrors }) => {
  const { store, mainService,messageService } = useDependency();
  const [legalForms, setLegalForms] = useState<any>([]);
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const[listMessageAction,setListMessageAction] = useState<any>([]);
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  const _message = (key: string) => t(`contact_messages.${key}`, { ns: 'contacts' });
  const getLegalForms = async () => {
    const legalForms = await mainService.listContactList(
      new ListContactListRequest(store.Server, store.SessionId, {
        list: "companylegalform",
      })
    );
    setLegalForms(legalForms.ITEM);
  };

  const getListMessageAction = async()=>{
      const response = await messageService.listMessageAction(new ListMessageActionRequest(store.Server, store.SessionId,{
              limit:100,
              offset:0
            }));
        setListMessageAction(response?.ROW || [])
    }

  useEffect(() => {
    getLegalForms(); 
    getListMessageAction();
  }, []);
  useEffect(() => {
    if(fieldConfig?.name1?.required
      ||fieldConfig?.regNumber?.required
      ||fieldConfig?.VATNumber?.required
      ||fieldConfig?.legalForm?.required
      ||fieldConfig?.category?.required
    ){
      setValidationStatus((prev:any) => ({ ...prev, ['companyInfoSection']: false }));
      setIsSectionRequired(true)
    } 
  }, [fieldConfig]);

  const handleSelectionChange = (key: any) => {
    setSelectedKey(key);
    const filteredLefalForm = legalForms.find((x: any) => x.id === key);
    onChange({
      ...data,
      legalForm: key,
      legalFormName: filteredLefalForm?.name || "",
    });
  };

  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("companyInfoSection") ? new Set() : new Set(["companyInfoSection"]));
  };
  
  const handleConfirm = ()=>{
    const errors:any = {};
    if(fieldConfig?.name1?.required && data.name1.trim() === ''){
      errors.name1 = _message('company_name_required');
    }
    if(fieldConfig?.legalForm?.required && data.legalForm.trim() === ''){
      errors.legalForm = _message('legal_form_required');
    }
    if(fieldConfig?.regNumber?.required && data.regNumber.trim() === ''){
      errors.regNumber = _message('registration_number_required');
    }
    if(fieldConfig?.VATNumber?.required && data.VATNumber.trim() === ''){
      errors.VATNumber = _message('vat_no_required');
    }
    if(fieldConfig?.category?.required && data.category.trim() === ''){
      errors.legalForm = _message('category_required');
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setValidationStatus((prev:any) => ({ ...prev, ['companyInfoSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['companyInfoSection']: true }));
    setExpandedSectionKey(new Set(['addressSection']))
  }

  const validateRequiredFields = ()=>{
    const errors:any = {};
    if(fieldConfig?.name1?.required && data.name1.trim() === ''){
      errors.name1 = _message('company_name_required');
    }
    if(fieldConfig?.legalForm?.required && data.legalForm.trim() === ''){
      errors.legalForm = _message('legal_form_required');
    }
    if(fieldConfig?.regNumber?.required && data.regNumber.trim() === ''){
      errors.regNumber = _message('registration_number_required');
    }
    if(fieldConfig?.VATNumber?.required && data.VATNumber.trim() === ''){
      errors.VATNumber = _message('vat_no_required');;
    }
    if(fieldConfig?.category?.required && data.category.trim() === ''){
      errors.legalForm = _message('category_required');
    }
    if (Object.keys(errors).length > 0) {
      setValidationStatus((prev:any) => ({ ...prev, ['companyInfoSection']: false }));
      return;
    }
    setValidationStatus((prev:any) => ({ ...prev, ['companyInfoSection']: true }));
  }

  useEffect(()=>{
    validateRequiredFields();
  },[data])

  return (
      <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="companyInfoSection"> 
        <DisclosureTitle>
        <Flex justifyContent="space-between" alignItems="center" width="100%">
      <View><span>{`${_t('base_info')}`}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
      {validationStatus.companyInfoSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
    </Flex>
        </DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
        <Flex direction="column" gap="size-100" width="100%">
        <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
        <CompanyNameDropDown
          validationErrors={validationErrors}
          textValue={data.name1}
          onBlur={()=>validateRequiredFields()}
          onChange={(company) => {
            onChange({
              ...data,
              name1: company.nazev,
              regNumber: company.ic,
              VATNumber: company.dic,
              city:company.mesto,
              street:company.ulice,
              zip:company.psc,
              country:company.stat
            });
            validateRequiredFields();
          }}
        />
        <ComboBox
            label={_t("legal_form")}
            items={legalForms}
            onSelectionChange={handleSelectionChange}
            onBlue={()=>validateRequiredFields()}
            width="100%"
            isRequired={fieldConfig?.legalForm?.required}
            selectedKey={data.legalForm}
            errorMessage={validationErrors.legalForm}
            validationState={fieldConfig?.legalForm?.required && validationErrors.legalForm ? data.legalForm === '' ? 'invalid' : 'valid' : undefined}
          >
            {(item: any) => <Item key={item.id}>{item.name}</Item>}
          </ComboBox>
        </Flex>
        <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
          <TextField
            label={_t("reg_no")}
            value={data.regNumber}
            isRequired={fieldConfig?.regNumber?.required}
            errorMessage={fieldConfig?.regNumber?.required && validationErrors.regNumber}
            validationState={fieldConfig?.regNumber?.required && validationErrors.regNumber ? data.regNumber === '' ? 'invalid' : 'valid' : undefined}
            onChange={(regNumber) => onChange({ ...data, regNumber })}
            onBlur={()=>{validateRequiredFields()}}
            width="100%"
          />
          <TextField
            label={_t("vat_no")}
            value={data.VATNumber}
            onChange={(VATNumber) => onChange({ ...data, VATNumber })}
            onBlur={()=>{validateRequiredFields()}}
            isRequired={fieldConfig?.VATNumber?.required}
            errorMessage={fieldConfig?.VATNumber?.required && validationErrors.VATNumber}
            validationState={fieldConfig?.VATNumber?.required && validationErrors.VATNumber ? data.VATNumber === '' ? 'invalid' : 'valid' : undefined}
            width="100%"
          />
        </Flex>
        <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
          <ComboBox
            label={_t("category")}
            onSelectionChange={(cat: any) => onChange({ ...data, category: cat })}
            onBlur={()=>{validateRequiredFields()}}
            isRequired={fieldConfig?.category?.required}
            errorMessage={fieldConfig?.category?.required && validationErrors.category}
            validationState={fieldConfig?.category?.required && validationErrors.category ? data.category === '' ? 'invalid' : 'valid' : undefined}
            width="100%"
          >
            <Item>''</Item>
          </ComboBox>
          <NumberField
          label={_t("due_days")}
          value={data.dueDays}
          onChange={(dueDays) => onChange({ ...data, dueDays })}
          width="100%"
          />
        </Flex>
        <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
          <ReferenceMarketingChanelDropDown
          selectedChanel={data.marketingChannel}
          onChange={(channel) => {
            const {refId,refName,refStandardtype} = channel; 
            onChange({...data,marketingChannel:refName,refId,refStandardtype}); 
          }}
        />
        <UserDropDown
              selectedUser={data.user}
              onChange={(user)=>{
                const {id,userName} = user;
                onChange({...data,user:userName});
              }}
              isHidden = {data.refStandardtype !== '2'}
             />
             <ComboBox
              label={_t("reference_code")}
              aria-label={_t("reference_code")}
              items={listMessageAction}
              selectedKey={data.trackingCode}
              onSelectionChange={(value)=>{
                onChange({...data,trackingCode:value?value.toString():""})
              }}
              width= {{base:"100%",L:"50%"}}
              // isRequired={isRequired}
              isHidden={data.refStandardtype !=="3"}
          >
            {(item:any) => (
              <Item key={item.code} textValue={item.code}>
                {item.code}
              </Item>
            )}
          </ComboBox>
        </Flex>
      </Flex>
      <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
                   <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                </Flex>
                <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
        </Disclosure>
        </Accordion>
  );
};
